import React from 'react';
import { useFormContext } from 'react-hook-form';

import { TextField, Flex } from '@simplybusiness/mobius-simplybusiness';

import SlashDivider from '../atoms/SlashDivider';
import Text from '../atoms/Text';
import Label from '../atoms/Label';
import ErrorMessage from '../atoms/ErrorMessage';

const ErnInput = () => {
  const { register, errors } = useFormContext();

  return (
    <>
      <Label>Enter your Employer PAYE Reference Number (ERN)</Label>
      <Text container="p" marginTop={10} marginBottom={10} fontSize={14}>
        It'll be up to 12 characters long – for example: 012/AA345678
      </Text>

      <Flex alignItems="flex-end" margin={0} marginBottom={4}>
        <TextField
          margin={0}
          name="taxOfficeCode"
          placeholder="012"
          width={67}
          marginRight="size-20"
          ref={register({ required: true, pattern: /^[0-9]{3}$/ })}
          validationState={errors.taxOfficeCode ? 'invalid' : ''}
        />

        <SlashDivider margin={0} />

        <TextField
          margin={0}
          name="taxOfficeEmployerReference"
          placeholder="AA345678"
          width={183}
          marginLeft="size-20"
          ref={register({ required: true, pattern: /^[A-Za-z]{1,2}[0-9]{1,6}$/ })}
          validationState={errors.taxOfficeEmployerReference ? 'invalid' : ''}
        />
      </Flex>
      { errors.taxOfficeCode
        && <ErrorMessage>The first part of your ERN will be made up of 3 numbers.</ErrorMessage>}
      { errors.taxOfficeEmployerReference
        && (
        <ErrorMessage>
          The second part of your ERN will be made up of 1-2 letters, followed by up to 6 numbers.
        </ErrorMessage>
        )}

    </>
  );
};

export default ErnInput;
